"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CycleCardDetails = CycleCardDetails;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _moment = _interopRequireDefault(require("moment"));
var _users = _interopRequireDefault(require("cccisd-icons/users2"));
var _cancelCircle = _interopRequireDefault(require("cccisd-icons/cancel-circle"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _user = _interopRequireDefault(require("cccisd-icons/user"));
var _unlocked = _interopRequireDefault(require("cccisd-icons/unlocked"));
var _lock = _interopRequireDefault(require("cccisd-icons/lock4"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdProgressBar = _interopRequireDefault(require("cccisd-progress-bar"));
var _admin = require("../../../../reducers/admin.js");
var _admin2 = require("../../../../selectors/admin.js");
var _form = _interopRequireDefault(require("../../CycleForm/form.js"));
var _CycleForm = require("../../CycleForm");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _generatePreviewHash = _interopRequireDefault(require("../../../../helpers/generatePreviewHash.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var DATE_FORMAT_MOMENT = 'D MMM YYYY, h:mm A';
function CycleCardDetails(_ref) {
  var cycle = _ref.cycle,
    deployments = _ref.deployments,
    rightSide = _ref.rightSide;
  var timepointText = cycle.timepoint ? "Timepoint: ".concat(cycle.timepoint) : '';
  var numRepeatChildren = deployments.filter(function (d) {
    return Number.parseInt(d.parentDeploymentId, 10) === Number.parseInt(cycle.deploymentId, 10);
  }).length;
  var timepointOrRepeated = cycle.settings.isRepeated ? "Repeated".concat(numRepeatChildren ? " (".concat(numRepeatChildren, ")") : '') : timepointText;
  var responses = cycle.numCompleted;
  var targetResponses = cycle.settings.targetResponses;
  var progress = Math.round(responses / targetResponses * 100);
  var getRespondentTypeLabel = function getRespondentTypeLabel() {
    var type = cycle.type;
    if (type === 'anon') {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_users["default"], null), " Anonymous");
    }
    if (type === 'group') {
      var role = cycle.roleHandle;
      var roleDef = AppDefs.pawn.roles.find(function (r) {
        return r.handle === role;
      });
      var label = roleDef ? roleDef.label : role.charAt(0).toUpperCase() + role.slice(1);
      if ((0, _get2["default"])(cycle, 'settings.closedRoster')) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_lock["default"], null), " ", label);
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_unlocked["default"], null), " ", label);
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_user["default"], null), " Known");
  };
  var getOpenStatus = function getOpenStatus() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: cycle.isOpen ? 'green' : 'red'
      }
    }, cycle.isOpen ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], {
      spaceRight: true
    }), "Open") : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cancelCircle["default"], {
      spaceRight: true
    }), "Closed"), cycle.isOpen && cycle.closesAt && !cycle.closedAt && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].infoText
    }, "Closes on ", (0, _moment["default"])(_moment["default"].utc(cycle.closesAt).format()).format(DATE_FORMAT_MOMENT)), !cycle.isOpen && cycle.opensAt && !cycle.openedAt && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].infoText
    }, "Opens on ", (0, _moment["default"])(_moment["default"].utc(cycle.opensAt).format()).format(DATE_FORMAT_MOMENT)));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].contentWrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].leftSide
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("strong", {
    className: _style["default"].title
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].tooltip
    }, cycle.label)
  }, cycle.label))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].timepointOrRepeated
  }, /*#__PURE__*/_react["default"].createElement("strong", null, timepointOrRepeated))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].divider
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, getRespondentTypeLabel(cycle)), /*#__PURE__*/_react["default"].createElement("div", null, getOpenStatus())), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "Completed responses: ", cycle.numCompleted || '–'), /*#__PURE__*/_react["default"].createElement("div", null, "Last response:", ' ', cycle.lastResponseEnteredAt ? (0, _moment["default"])(cycle.lastResponseEnteredAt).format(DATE_FORMAT_MOMENT) : '–')), targetResponses && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].progBar
  }, "Target Responses: ", targetResponses, /*#__PURE__*/_react["default"].createElement(_cccisdProgressBar["default"], {
    percentage: progress
  }))), rightSide && rightSide());
}
var CycleCard = /*#__PURE__*/function (_React$Component) {
  function CycleCard() {
    var _this;
    _classCallCheck(this, CycleCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CycleCard, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false
    });
    _defineProperty(_this, "getInitialValues", function () {
      var cycle = _this.props.cycle;
      var settings = _this.props.cycle.settings;
      var closesOn = cycle.closesAt ? _moment["default"].utc(cycle.closesAt).toDate() : '';
      var opensOn = cycle.opensAt ? _moment["default"].utc(cycle.opensAt).toDate() : '';
      var typeToRespondentConfig = {
        anon: 'anonymous',
        known: 'manual',
        group: 'managed'
      };
      return {
        allowRetake: settings.allowRetake,
        autoLogout: settings.autoLogout,
        autoLogoutTime: settings.autoLogoutTime,
        anonAutoLogoutMessage: settings.anonAutoLogoutMessage,
        branchedCompletionConfig: settings.branchedCompletionConfig || {},
        chainEmailFromPawn: settings.chainEmailFromPawn || '',
        chainPhoneFromPawn: settings.chainPhoneFromPawn || '',
        chainLanguageFromPawn: settings.chainLanguageFromPawn || '',
        closeOnTarget: settings.closeOnTarget,
        closedMessage: settings.closedMessage || 'This survey is no longer accepting responses.',
        closedRoster: settings.closedRoster || false,
        closesOn: closesOn,
        completedMessage: settings.completedMessage || 'You have already completed this survey. Thank you!',
        completionMessage: settings.completionMessage || 'You have completed the survey! Thank you for your response!',
        completionUrl: settings.completionUrl || '',
        description: cycle.description,
        endpoint: cycle.endpoint || '',
        handle: cycle.handle,
        hash: cycle.hash,
        individualPasscode: settings.individualPasscode,
        isAssignmentPlanEligible: settings.isAssignmentPlanEligible || false,
        isRepeated: settings.isRepeated || false,
        knownAutoLogoutMessage: settings.knownAutoLogoutMessage,
        logoutOnCompletion: settings.logoutOnCompletion || false,
        metricToRespondentPropertyMappings: settings.metricToRespondentPropertyMappings || [],
        name: cycle.label,
        open: cycle.isOpen,
        opensOn: opensOn,
        options: settings.options || [],
        otherAllowedRoles: settings.otherAllowedRoles || [],
        passcodeAssistant: settings.passcodeAssistant,
        passcodeBackground: settings.passcodeBackground,
        passcodeBackgroundColor: settings.passcodeBackgroundColor,
        passcodeBackgroundUpload: settings.passcodeBackgroundUpload,
        passcodeCompletionButtonText: settings.passcodeCompletionButtonText,
        passcodeLabel: settings.passcodeLabel,
        postCompletionAction: settings.postCompletionAction || (settings.sendToUrl ? 'url' : 'message'),
        recaptcha: settings.recaptcha,
        repeatInterval: settings.repeatInterval || '',
        requireLogin: settings.requireLogin,
        requirePass: settings.requirePass,
        respondentConfig: settings.respondentConfig || typeToRespondentConfig[cycle.type],
        respondentSelection: settings.respondentSelection || cycle.roleHandle,
        showReviewButtonOnCompletion: settings.showReviewButtonOnCompletion || false,
        targetResponses: settings.targetResponses,
        timepoint: cycle.timepoint,
        useEndpoint: settings.useEndpoint
      };
    });
    _defineProperty(_this, "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
        var cycle, response, errMsg, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              cycle = _this.props.cycle;
              _context.p = 1;
              _context.n = 2;
              return _this.props.updateWave(cycle.deploymentId, (0, _CycleForm.getParams)(values, cycle.settings));
            case 2:
              response = _context.v;
              if (!(response.data.status === 'success')) {
                _context.n = 3;
                break;
              }
              _this.modal.close();
              (0, _cccisdNotification["default"])('Data Collection Wave successfully updated');
              _context.n = 4;
              break;
            case 3:
              errMsg = response.data.errors && response.data.errors.group ? response.data.errors.group.join(', ') : 'Data Collection Wave update failed';
              (0, _cccisdNotification["default"])({
                message: errMsg,
                type: 'danger'
              });
              if (!(response.data.status === 'error')) {
                _context.n = 4;
                break;
              }
              return _context.a(2, Promise.reject(response.data.errors));
            case 4:
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              return _context.a(2, Promise.reject(_t));
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 5]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getSurveyList", function () {
      var result = [];
      var _iterator = _createForOfIteratorHelper(_this.props.assignment.surveylistList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _result;
          var sl = _step.value;
          (_result = result).push.apply(_result, _toConsumableArray(sl.surveyList));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      result = (0, _sortBy2["default"])((0, _uniqBy2["default"])(result, 'surveyHandle'), 'position');
      var languages = _this.props.assignment.settings.languages;
      result.forEach(function (survey) {
        survey.readyForDeploy = languages.every(function (lang) {
          return survey.flowList.find(function (flow) {
            return flow.language === lang;
          });
        });
      });
      return result;
    });
    return _this;
  }
  _inherits(CycleCard, _React$Component);
  return _createClass(CycleCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // make sure respondent count is up-to-date
      this.props.reloadCurrentProject();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        cycle = _this$props.cycle,
        deployments = _this$props.deployments,
        assignment = _this$props.assignment;
      var assignmentId = assignment.assignmentId,
        groupId = assignment.groupId;
      var deploymentId = cycle.deploymentId;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/_react["default"].createElement(CycleCardDetails, {
        cycle: cycle,
        deployments: deployments,
        rightSide: function rightSide() {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].rightSide
          }, /*#__PURE__*/_react["default"].createElement("a", {
            type: "button",
            className: "btn btn-primary btn-sm",
            target: "_blank",
            rel: "noopener noreferrer",
            href: Boilerplate.url("quest/preview/quest/".concat(assignmentId, "/").concat((0, _generatePreviewHash["default"])(assignmentId), "/").concat(deploymentId))
          }, /*#__PURE__*/_react["default"].createElement(_eye["default"], {
            spaceRight: true
          }), "Preview Deployment"), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("button", {
              type: "button",
              "data-deployment-edit-button": deploymentId,
              className: "btn btn-success btn-sm"
            }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], {
              spaceRight: true
            }), " Edit Settings"),
            title: /*#__PURE__*/_react["default"].createElement("div", null, "Edit ", cycle.label),
            ref: function ref(elem) {
              _this2.modal = elem;
            },
            size: "large"
          }, /*#__PURE__*/_react["default"].createElement(_form["default"], {
            assignmentId: assignmentId,
            groupId: groupId,
            onSubmit: _this2.onSubmit,
            deploymentId: deploymentId,
            initialValues: _this2.getInitialValues(),
            numCompleted: cycle.numCompleted,
            numInProgress: cycle.numInProgress,
            surveyList: _this2.getSurveyList(),
            deployment: cycle
          })));
        }
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(CycleCard, "propTypes", {
  assignment: _propTypes["default"].object,
  closeModal: _propTypes["default"].func,
  cycle: _propTypes["default"].object,
  deployFilter: _propTypes["default"].string,
  deployments: _propTypes["default"].array,
  projectLinks: _propTypes["default"].object,
  reloadCurrentProject: _propTypes["default"].func,
  removeWave: _propTypes["default"].func,
  updateWave: _propTypes["default"].func
});
var _default = exports["default"] = (0, _reactRedux.connect)(function (state) {
  return {
    deployFilter: state.assignment.admin.deployFilter,
    deployments: (0, _admin2.getCurrentProjectDeployments)(state.assignment.admin),
    projectLinks: (0, _admin2.getProjectLinks)(state.assignment.admin)
  };
}, {
  reloadCurrentProject: _admin.reloadCurrentProject,
  removeWave: _admin.removeWave,
  updateWave: _admin.updateWave
})(CycleCard);